import React, { Component } from 'react'
import patient from '../../stores/patient'
import styled from 'styled-components'
import Text from '../../components/Text'

const Row = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  & > * {
    flex: 1;
  }
  padding: 1rem;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  margin-bottom: 3rem;
  ${props => props.breakBefore && 'break-before: page;'}
  
  @media print {
    margin-bottom: 0;
  }
`

const Cell = styled.div`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  ${props => props.justifyEnd && 'justify-content: flex-end;'}
  
  @media print {
    font-size: 1rem;
  }
`

const Label = styled.span`
  margin-right: 0.5em;
  opacity: 0.8;
`

const Bold = styled.div`
  font-weight: 500;
`

const current = new Date();
const date = `${current.getMonth()+1}/${current.getDate()}/${current.getFullYear()}`;

export default class  extends Component {
  render() {
    return (
      <Row {...this.props}>
        <Cell>
          <Label><Text str="Patient:" /></Label>
          <Bold>{patient.fields.name}</Bold>
        </Cell>
        <Cell justifyEnd>
          <Label><Text str="Date:" /></Label>
          <Bold>{date}</Bold>
        </Cell>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/NameDate.js